<main class="main" id="top">
    <div class="container-fluid p-4">
        <div class="container">
            <div class="row">
                <div class="col-md-6 mx-auto mt-5">
                    <div class="payment">
                        <div class="payment_header">
                            <div class="check"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
                        </div>
                        <div class="content">

                            <h1> Opps ! Something Went Wrong </h1>
                            <p>Transaction Failed</p>
                            <a routerLink="/auth/subscription">Go to Home</a>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</main>